import React, { Component } from 'react';
import { FormControl, FormGroup, Card, Row, Col, Button } from 'react-bootstrap';
import DateTime from 'react-datetime';

class PipEposObjectivesSearch extends Component {
  render() {
    const {
      objectiveName,
      startDateFrom,
      endDateTo,
      onHandleObjectiveNameChange,
      onHandleStartDateFromChange,
      onHandleEndDateToChange,
      onHandleSearch,
      onHandleClear,
      onHandleDownload
    } = this.props;

    return (
      <Card className="admin-search-filter">
        <Card.Body>
          <Row>
            <Col md={3}>
              <FormGroup>
                Objective name
                <FormControl
                  value={objectiveName}
                  onChange={onHandleObjectiveNameChange}
                  placeholder="Enter Epos Objective name"
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                Start Date From
                <DateTime
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  value={startDateFrom}
                  onChange={onHandleStartDateFromChange}
                  inputProps={
                  { placeholder: 'Start Date From'}
                }
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                End Date To
                <DateTime
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  value={endDateTo}
                  onChange={onHandleEndDateToChange}
                  inputProps={
                  { placeholder: 'End Date To'}
                }
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6} className="actions">
              <Button
                className="red-ghost-btn"
                onClick={onHandleSearch}
              >
                Search
              </Button>
              <Button
                className="red-ghost-btn"
                onClick={onHandleClear}
              >
                Clear filters
              </Button>
              <Button
                className="red-ghost-btn"
                onClick={onHandleDownload}
              >
                Download
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  }
}

export default PipEposObjectivesSearch;
